import { Home, PlusCircle, Shield, Users } from "lucide-react";
export const navigationItems = [
    {
        label: "Tickets",
        path: "/",
        icon: Home,
    },
    {
        label: "New Ticket",
        path: "/tickets/new",
        icon: PlusCircle,
    },
    {
        label: "Admin",
        path: "/admin",
        icon: Shield,
        adminOnly: true,
    },
    {
        label: "Users",
        path: "/admin/users",
        icon: Users,
        adminOnly: true,
    },
];
